export default __webpack_public_path__ + "static/media/m5.1b6cad8e.jpg";